import { PLACEMENT } from "components/ui/utils/constant";
import { AIContext, aiSizeOptions } from "contexts/AIContext";
import { useContext } from "react";
import { HiCheckCircle } from "react-icons/hi";

const { Dropdown, Tooltip } = require("components/ui");

const AIImageDropdownSizes = ({
    size,
    setSize,
    model,
    placement = PLACEMENT.CENTER_CENTER,
    className = "",
    parentClassName = ""
}) => {

    const { aiModels } = useContext(AIContext);
    const aiSizeFilteredOptions = aiSizeOptions.filter(e => aiModels?.find(m => m.model == model)?.availableSizes?.includes(e.id));

    return (
        <Dropdown
            menuClass="max-h-[290px] min-w-[60px] w-[60px] overflow-y-auto !rounded-2xl !border-0 !p-0"
            placement={placement}
            parentClassName={parentClassName}
            renderTitle={
                <div className={`cursor-pointer overflow-hidden !px-4 whitespace-nowrap !py-2.5 !h-auto bg-gray-50 dark:bg-gray-600 rounded-2xl !text-center flex items-center font-semibold ${className} !leading-[14px]`}>
                    {aiSizeFilteredOptions?.filter(e => e.id == size)?.[0]?.label || aiSizeFilteredOptions?.[0]?.label}
                </div>
            }
        >
            {aiSizeFilteredOptions?.sort((a, b) => aiSizeFilteredOptions?.map(e => e.id)?.includes(b?.id) - aiSizeFilteredOptions?.map(e => e.id)?.includes(a?.id)).map((_size, key) => (
                <Dropdown.Item 
                    key={_size.id}
                    eventKey={_size.id} 
                    onSelect={() => setSize(_size.id)}
                    className={`flex items-center justify-center !py-2 !text-center hover:!bg-gray-100 dark:hover:!bg-gray-900/20 gap-3 ${size === _size.id ? 'bg-purple-50 dark:bg-purple-900/20' : ''}`}
                >
                    <div className="font-medium">{_size.label}</div>
                </Dropdown.Item>
            ))}
        </Dropdown>
    );
}

export default AIImageDropdownSizes;